import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from 'common/consts/kentico';

class ContentService {
  async fetchContent() {
    return (
      Client.items()
        .type(KENTICO_TYPES.CONTENT)
        .limitParameter(1)
        .depthParameter(3)
        // .orderParameter('system.last_modified', SortOrder.desc)
        .toPromise()
    );
  }
}

export default new ContentService();



// WEBPACK FOOTER //
// ./src/services/Content.service.js